export default __webpack_public_path__ + "static/media/news6.97b7e123.webp";